import { useMemo } from "react";
import { getClient, customChains } from "@reservoir0x/reservoir-sdk";
import { zeroAddress } from "viem";
import * as allChains from "viem/chains";
export default (chainId) => {
    const client = getClient();
    const reservoirChain = useMemo(() => chainId
        ? client.chains.find((chain) => chain.id === chainId)
        : client.currentChain(), [client, chainId]);
    const chains = Object.values({ ...allChains, ...customChains });
    let chain = useMemo(() => chains.find((chain) => (reservoirChain === null || reservoirChain === void 0 ? void 0 : reservoirChain.id) === chain.id), [chains, reservoirChain]);
    if (!chain && chains.length > 0) {
        chain = chains[0];
    }
    const ETHChains = [allChains.mainnet.id, allChains.goerli.id];
    if (!chain || !chain.nativeCurrency || ETHChains.includes(chain.id)) {
        return {
            name: "Ethereum",
            symbol: "ETH",
            decimals: 18,
            address: zeroAddress,
            chainId: (chain === null || chain === void 0 ? void 0 : chain.id) || allChains.mainnet.id,
        };
    }
    else if (chain.id === allChains.skaleNebula.id) {
        return {
            name: "Europa ETH",
            symbol: "ETH",
            decimals: 18,
            address: "0xab01bad2c86e24d371a13ed6367bdca819589c5d",
            chainId: 1482601649,
        };
    }
    else {
        return {
            ...chain.nativeCurrency,
            address: zeroAddress,
            chainId: chain.id,
        };
    }
};
